import React, { useEffect, useState,useRef } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { Card, Button, Collapse, Row, Col, Badge } from "react-bootstrap";
import { ArrowDown, CaretDown, CaretUp } from "@phosphor-icons/react";
import { API_URL } from "..";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { useMapbox } from "../GoogleMapsContext";

const options = [
  { value: "Light Duty Towing", label: "Light Duty Towing" },
  { value: "Medium Duty Towing", label: "Medium Duty Towing" },
  { value: "Heavy Duty Towing", label: "Heavy Duty Towing" },
  { value: "Flatbed Towing", label: "Flatbed Towing" },
  { value: "Motorcycle Towing", label: "Motorcycle Towing" },
  { value: "Long-Distance Towing", label: "Long-Distance Towing" },
  { value: "Emergency Towing", label: "Emergency Towing" },
  { value: "Accident Recovery", label: "Accident Recovery" },
  { value: "Winch-Out Services", label: "Winch-Out Services" },
  { value: "Roadside Assistance", label: "Roadside Assistance" },
  { value: "Fuel Delivery", label: "Fuel Delivery" },
  { value: "Lockout Services", label: "Lockout Services" },
  { value: "Tire Change Services", label: "Tire Change Services" },
  { value: "Jump Start Services", label: "Jump Start Services" },
  { value: "Impound Towing", label: "Impound Towing" },
  { value: "Specialty Vehicle Towing", label: "Specialty Vehicle Towing" },
  { value: "Classic Car Towing", label: "Classic Car Towing" },
  { value: "Fleet Services", label: "Fleet Services" },
  { value: "Commercial Towing", label: "Commercial Towing" },
  {
    value: "Recreational Vehicle Towing",
    label: "Recreational Vehicle Towing",
  },
];

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
const AssignJob = () => {
  const location = useLocation();
  const { mapboxgl } = useMapbox(); // Get mapboxgl from context
  const {assigned_To} = location.state || [{}];
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [showAlertMessage, setshowAlertMessage] = useState({
    status: false,
    message: "",
    desc: "",
  });
  const [selectedPlace, setSelectedPlace] = useState(null); // Incident location
  const [selectedPlaceDropoff, setSelectedPlaceDropoff] = useState(null); // Dropoff location
  const [phone, setPhone] = useState("");
  const [jobType, setJobType] = useState("");
  const [callType, setCallType] = useState("New Call");
  const [priority, setPriority] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedOptionService, setSelectedOptionService] = useState([]);
  const [selectDriver, setSelectDriver] = useState([]);
  const [selectDriverSelect, setSelectDriverSelect] = useState({});
  const [affiliatesData, setAffilatesData] = useState(assigned_To);
  const [filterAffilatesData, setFilterAffilatesData] = useState([]);
    const [services, setServices] = useState([]);
  const [extraCosts, setExtraCosts] = useState([]);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [DriverData, setDriverData] = useState(null);
  const [completedDates, setCompletedDates] = useState({
    receivedDate: "",
    dispatchedDate: "",
    enRouteDate: "",
    onSceneDate: "",
    towingDate: "",
    destinationDate: "",
    completedDate: "",
  });
  const [scheduleDate, setScheduleDate] = useState("");


  const onChangeCompany = async (selected) => {
    setSelectDriverSelect({});
    let headersList = {
      Accept: "*/*",
      // "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };

    try {
      const response = await fetch(
        `${API_URL}/api/driver/fetch/${selected}`,
        { headers: headersList, method: "GET" }
      );
      const data = await response.json();
      const formattedData = data.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));

      setSelectDriver(formattedData);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleChange = (selected) => {
    setSelectedOptions(selected);
    onChangeCompany(selected.value);
  };
  const handleChangeService = (selected) => {
    setSelectedOptionService(selected || []);
  };
  const handleChangeDriver = (selected) => {
    setSelectDriverSelect(selected || []);
  };
  const [jobsData, setJobData] = useState([]);
  const fetchJobs = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };
    let response;
    if (user.role === "owner") {
      response = await fetch(
        `${API_URL}/api/affiliates/fetch-affiliate/${user.id}`,
        {
          method: "GET",
          headers: headersList,
        }
      );
      onChangeCompany(user.id);
      let data = await response.json();
      setJobData([{ value: data.id, label: data.business_name }]);
    } else {
      response = await fetch(
        API_URL+"/api/affiliates/fetch-affiliates",
        {
          method: "GET",
          headers: headersList,
        }
      );
      let data = await response.json();

      const formattedData = data.map((e) => ({
        value: e.id,
        label: e.business_name,
      }));
      setJobData(formattedData);
    }
  };
  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");

    // Format the number as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    const formatted = [
      match[1] && `(${match[1]}`,
      match[2] && `) ${match[2]}`,
      match[3] && `-${match[3]}`,
    ]
      .filter(Boolean)
      .join("");

    return formatted;
  };
  const handleInputChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };
  React.useEffect(() => {
    fetchJobs();
  }, [1]);
  const onFormSubmit = async (event) => {
    event.preventDefault();

    const formattedData = selectedOptionService.map((e) => e.value);
    if (event.target.elements.fullname.value < 3) {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Customer name is invalid",
      });
      return false;
    } else if (phone === "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Phone Number is not empty",
      });
      return false;
    } else if (jobType === "") {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Select the job type",
      });
      return false;
    } else if (selectedOptionService.length === 0) {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Select the service",
      });
      return false;
    } else {
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };
      let bodyContent = JSON.stringify({
        fullname: event.target.elements.fullname.value,
        
        phone: event.target.elements.phone.value,
        address: selectedPlace?.address,
        dropoff_address: selectedPlaceDropoff?.address,
        zipcode: event.target.elements.zipcode.value,
        job_cost: event.target.elements.job_cost.value,
        
        assigned_by: currentUser?.id,
        driver_id: selectDriverSelect?.value,
        job_type: jobType,
        priority: priority,
        license_plate: event.target.elements.license_plate.value,
        vehicle_type: event.target.elements.vehicle_Type.value,
        vehicle_year: event.target.elements.vehicle_Year.value,
        vehicle_make: event.target.elements.vehicle_Make.value,
        vehicle_model: event.target.elements.vehicle_Model.value,
        vehicle_color: event.target.elements.vehicle_Color.value,
        vin: event.target.elements.vin.value,
        service_request: formattedData?.toString(),
        recieved_time:completedDates.receivedDate,
        dipatched_time:completedDates.dispatchedDate,
        enroute_time:completedDates.enRouteDate,
        onscene_time:completedDates.onSceneDate,
        towing_time:completedDates.towingDate,
        destination_time:completedDates.destinationDate,
        completed_time: completedDates.completedDate,
        scheduled_date:scheduleDate,
        description: event.target.elements.description.value,
        job_posted_to: singleCheckedArray?.toString(),
      });
      const response = await fetch(API_URL+"/api/jobs", {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        });
      let data = await response.json();
      if (response.status == 201) {
        setshowAlertMessage({
          message: "success",
          status: true,
          desc: "Job Is assigned successfully",
        });
        setPhone("");
        event.target.elements.fullname.value = "";
        // event.target.elements.phone.value='';
        event.target.elements.address.value = "";
        event.target.elements.zipcode.value = "";
        event.target.elements.job_cost.value = "";
        setAffilatesData([])
        setFilterAffilatesData([])
        setSelectedOptions({});
        setSelectedOptionService([]);
        // event.target.elements.assigned_to.value='';
        event.target.elements.description.value = "";
      } else {
        setshowAlertMessage({
          message: "error",
          status: true,
          desc: "Error while adding new job",
        });
      }
    }
  };
  const [currentUser, setCurrentUser] = useState({});
  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user == null) {
      window.location.href = "/sign-in";
    } else {
      setCurrentUser(user);
    }
  };
  useEffect(() => {
    getCurrentUser();
  }, [1]);
   const filter = affiliatesData.map((e)=>e.id);
  const [singleCheckedArray, setSingleCheckedArray] = useState(filter);

  const handleCheckboxChange = (e, index) => {
    const checked = e.target.checked;
    const affiliate = affiliatesData[index];
    if (checked) {
      setSingleCheckedArray([...singleCheckedArray, affiliate]);
    } else {
      setSingleCheckedArray(
        singleCheckedArray.filter((item) => item !== affiliate)
      );
    }
  };

  const handleAssignClick = (index) => {
     
    const affiliate = filterAffilatesData[index];
    if (!singleCheckedArray.includes(affiliate.id)) {
      const updatedAffiliatesData = [...affiliatesData];
      updatedAffiliatesData[index].status = "marked";
      setFilterAffilatesData(updatedAffiliatesData);
      setSingleCheckedArray([...singleCheckedArray, affiliate.id]); // Store only the ID
    }
  };

  const handleRemoveClick = (index) => {
    const affiliate = filterAffilatesData[index];
    const updatedSingleCheckedArray = singleCheckedArray.filter(
      (id) => id !== affiliate.id
    );
    const updatedAffiliatesData = [...affiliatesData];
    updatedAffiliatesData[index].status = "active";
    setFilterAffilatesData(updatedAffiliatesData);
    setSingleCheckedArray(updatedSingleCheckedArray);
  };
  const [openIndex, setOpenIndex] = useState(null);

  const toggleExpand = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [listType, setListType] = useState('show_all')
  useEffect(()=>{
      const filteredData = ()=>{
              if(listType == 'active_only'){
                const filter = affiliatesData.filter((e)=>e.status === 'active' || e.status == 'marked');
                setFilterAffilatesData(filter);
              }else{
                setFilterAffilatesData(affiliatesData)
                // const filter = affiliatesData.filter((e)=>e.status === 'active');
              }
              
      }
      filteredData();
  },[listType])
  const incidentGeocoderRef = useRef(null);
  const dropoffGeocoderRef = useRef(null);
  const [eta,setEta] = useState(null)
  const [isMounted,setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
      // Cleanup geocoders when unmounting
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
        incidentGeocoderRef.current = null;
      }
      if (dropoffGeocoderRef.current) {
        dropoffGeocoderRef.current.onRemove();
        dropoffGeocoderRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !mapboxgl.accessToken) return;

    // Clear existing containers
    const clearContainer = (id) => {
      const container = document.getElementById(id);
      if (container) container.innerHTML = '';
      return container;
    };

    const incidentContainer = clearContainer('incident-location-container');
    const dropoffContainer = clearContainer('dropoff-location-container');

    if (!incidentContainer || !dropoffContainer) return;

    // Initialize geocoders with fresh instances
    incidentGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Enter incident location',
      marker: false,
      
    });

    dropoffGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Enter dropoff location',
      marker: false
    });

    // Add to DOM
    incidentGeocoderRef.current.addTo(incidentContainer);
    dropoffGeocoderRef.current.addTo(dropoffContainer);

    // Event handlers
    incidentGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      setSelectedPlace({
        address: place_name,
        lat: center[1],
        lng: center[0],
        name: place_name.split(',')[0]
      });
    });

    dropoffGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      const drop = {
        address: place_name,
        lat: center[1],
        lng: center[0],
        name: place_name.split(',')[0]
      }
      setSelectedPlaceDropoff(drop);

      calculateETA(selectedPlace, drop)
    });
    return () => {
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
      }
      if (dropoffGeocoderRef.current) {
        dropoffGeocoderRef.current.onRemove();
      }
    };
  }, [isMounted]);
  const calculateETA = async (origin, destination) => {
    try {
      if (!origin || !destination) {
        throw new Error("Both origin and destination are required");
      }

      const response = await fetch(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${origin.lng},${origin.lat};${destination.lng},${destination.lat}?access_token=${mapboxgl.accessToken}`
      );
      
      if (!response.ok) {
        throw new Error(`Directions API error: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.routes && data.routes.length > 0) {
        const duration = data.routes[0].duration;
        const minutes = Math.round(duration / 60);
        setEta({
          seconds: duration,
          text: `${minutes} min`,
          distance: data.routes[0].distance // Adding distance in meters
        });
        setshowAlertMessage({
          message: "error",
          status: false,
          desc: "No route found between locations",
        });
      } else {
        setEta(null);
        setshowAlertMessage({
          message: "error",
          status: true,
          desc: "No route found between locations",
        });
      }
    } catch (error) {
      console.error("Error calculating ETA:", error);
      setEta(null);
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Error calculating route. Please check locations.",
      });
    }
  };
    return (
      <>
        {/* MasterLayout */}
        <MasterLayout>
          {/* Breadcrumb */}
          <Breadcrumb title="Assign Job" />

          {/* AddUserLayer */}
          <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
              <div className="row">
                <div className="col-xxl-6 col-xl-8 col-lg-10">
                  <div className="card border">
                    <div className="card-body">
                      {/* Upload Image Start */}

                      {/* Upload Image End */}
                      <form onSubmit={(event) => onFormSubmit(event)}>
                        <div className="mb-20">
                          <div class="row">
                           <div className="col-md-6">
          <label
            htmlFor="address"
            className="form-label fw-semibold text-primary-light text-sm mb-8"
          >
            Incident Location
            <span className="text-danger-600">*</span>
          </label>
          <div 
          id="incident-location-container"
          key={`incident-${isMounted}`} // Force re-creation
          style={{ minHeight: '50px' }}
        />
        <input
          type="hidden"
          name="address"
          value={selectedPlace?.address || ''}
          required
        />
        </div>
        <div className="col-md-6">
        <label
            htmlFor="dropoff_address"
            className="form-label fw-semibold text-primary-light text-sm mb-8"
          >
            Dropoff Location
            <span className="text-danger-600">*</span>
          </label>
        <div 
          id="dropoff-location-container"
          key={`dropoff-${isMounted}`} // Force re-creation
          style={{ minHeight: '50px' }}
        />
        <input
          type="hidden"
          name="dropoff_address"
          value={selectedPlaceDropoff?.address || ''}
          required
        />
          <input
            type="hidden"
            className="form-control radius-8"
            id="zip_code"
            name="zipcode"
            placeholder="ZipCode"
          />
        </div>
        {eta && (
        <div className="mt-3 alert alert-info col-md-12 mb-4">
          <p className="mb-0">
            Estimated Travel Time: <strong>{eta.text}</strong> ({Math.round(eta.seconds / 60)} minutes)
            {eta.distance && (
              <span>, Distance: {Math.round(eta.distance / 1000)} km</span>
            )}
          </p>
        </div>
      )}
                          </div>
                        </div>
                      
                        <div className="mb-20">
                          <label
                            htmlFor="name"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Full Name <span className="text-danger-600">*</span>
                          </label>
                          <input
                            type="text"
                            name="fullname"
                            className="form-control radius-8"
                            id="name"
                            placeholder="Enter Full Name"
                          />
                        </div>
                        <div className="mb-20">
                          <div className="row">
                           
                            <div className="col-md-12">
                              <label
                                htmlFor="phone"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Phone  <span className="text-danger-600">*</span>
                              </label>
                              <input
                                type="tel"
                                name="phone"
                                value={phone}
                                onChange={handleInputChange}
                                className="form-control radius-8"
                                id="phone"
                                placeholder="Enter Phone Number"
                              />
                            </div>
                          </div>
                        </div>

                       
                        <div className="mb-20">
                          <div class="row">
                            <div class="col-md-6">
                              <label
                                htmlFor="zip_code"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                ZipCode
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="zip_code"
                                name="zipcode"
                                placeholder="ZipCode"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                htmlFor="job_cost"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Job Cost
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="job_cost"
                                name="job_cost"
                                placeholder="0.00"
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <h6>Vehicle Information</h6>
                        </div>
                        <div className="mb-20">
                          <div class="row">
                            <div class="col-md-6">
                              <label
                                htmlFor="license_plate"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                License Plate
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="license_plate"
                                name="license_plate"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                htmlFor="vin"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                VIN
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vin"
                                name="vin"
                              />
                            </div>
                            <div style={{ paddingTop: 10 }} />
                            <div class="col-md-4">
                              <label
                                htmlFor="vehicle_Type"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Type
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vehicle_Type"
                                name="vehicle_Type"
                              />
                            </div>
                            <div class="col-md-4">
                              <label
                                htmlFor="vehicle_Year"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Year
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vehicle_Year"
                                name="vehicle_Year"
                              />
                            </div>
                            <div class="col-md-4">
                              <label
                                htmlFor="vehicle_Make"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Make
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vehicle_Make"
                                name="vehicle_Make"
                              />
                            </div>
                            <div style={{ paddingTop: 10 }} />
                            <div class="col-md-4">
                              <label
                                htmlFor="vehicle_Model"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Model
                              </label>
                              <input
                                type="text"
                                className="form-control radius-8"
                                id="vehicle_Model"
                                name="vehicle_Model"
                              />
                            </div>
                            <div class="col-md-4">
                              <label
                                htmlFor="vehicle_Color"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                              >
                                Vehicle Color
                              </label>
                              <input
                                type="color"
                                className="form-control radius-8"
                                id="vehicle_Color"
                                name="vehicle_Color"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Priority
                            <span className="text-danger-600">*</span>{" "}
                          </label>
                          <div className="d-flex align-items-center flex-wrap gap-28">
                            <div className="form-check checked-primary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal11"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"Normal"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal11"
                              >
                                Normal{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal22"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"Emergency"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal22"
                              >
                                Emergency{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="priority"
                                id="horizontal23"
                                onChange={(e) => setPriority(e.target.value)}
                                value={"Low"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal23"
                              >
                                Low{" "}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Job Type
                            <span className="text-danger-600">*</span>{" "}
                          </label>
                          <div className="d-flex align-items-center flex-wrap gap-28">
                            <div className="form-check checked-primary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="horizontal"
                                id="horizontal1"
                                onChange={(e) => setJobType(e.target.value)}
                                value={"Roadside Assistance"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal1"
                              >
                                Roadside Assistance{" "}
                              </label>
                            </div>
                            <div className="form-check checked-secondary d-flex align-items-center gap-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="horizontal"
                                id="horizontal2"
                                onChange={(e) => setJobType(e.target.value)}
                                value={"Towing Service"}
                              />
                              <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="horizontal2"
                              >
                                Towing Service{" "}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-20">
                          <label
                            htmlFor="assigned_to"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Service Required
                            <span className="text-danger-600">*</span>{" "}
                          </label>
                          <Select
                            options={options}
                            isMulti
                            value={selectedOptionService}
                            onChange={handleChangeService}
                            placeholder="Select Options"
                          />
                        </div>
                   

                        <div className="mb-20">
                          <label
                            htmlFor="desc"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control radius-8"
                            id="desc"
                            placeholder="Write description..."
                            name="description"
                          />
                        </div>
                        {showAlertMessage.status === true ? (
                          <div
                            className={
                              showAlertMessage.message == "error"
                                ? "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                                : "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                            }
                            role="alert"
                          >
                            {showAlertMessage.desc}
                            <button
                              type="button"
                              onClick={() =>
                                setshowAlertMessage(!showAlertMessage)
                              }
                              className="remove-button text-secondary-600 text-xxl line-height-1"
                            >
                              {" "}
                              <Icon
                                icon="iconamoon:sign-times-light"
                                className="icon"
                              />
                            </button>
                          </div>
                        ) : null}
                        <div className="d-flex align-items-center justify-content-center gap-3">
                          <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-8 col-lg-10">
                  <div className="card border">
                    <div className="card-body">
        
                      <div >
                      <div style={{overflowY:'scroll' , height : 800}} >
                      {filterAffilatesData.map((e, index) => (
                       <div key={index} className="row">
                        <div  className="col-xl-12 mb-1">
                          <Card className="radius-12 overflow-hidden d-flex align-items-center flex-nowrap flex-row">
                            <Card.Body className="p-16 flex-grow-1">
                              <Row>
                                <Col md="8">
                                <input
                                type="checkbox"
                                checked={singleCheckedArray.includes(e.id)}
                                onChange={(event) => handleCheckboxChange(event, index)}
                              />

                              {/* Business Name (Toggle Button) */}
                              <Button 
                                variant="link"
                                style={{textDecoration:'none'}}
                                onClick={() => toggleExpand(index)}
                                className="text-primary-light text-lg p-0"
                              >
                                {e?.business_name} {openIndex === index ?  <CaretUp/>:<CaretDown/>  } 
                              </Button>

                              {/* Services List (Toggles on Click) */}
                              <Collapse in={openIndex === index}>
                                <div className="mt-2">
                                  <ul className="pl-4">
                                    {e.services_provided?.length > 0 ? (
                                      e?.services_provided.split(',').map((service, idx) => (
                                        <li key={idx} className="text-gray-700">✔ {service}</li>
                                      ))
                                    ) : (
                                      <li className="text-muted">No services available</li>
                                    )}
                                  </ul>
                                </div>
                              </Collapse>
                                      <br/>
                              <span>No Trucks: {e?.no_of_trucks}</span><br />
                              <span>Status: {e?.status}</span><br />
                              <span>Distance: {Math.round(parseFloat(e?.distance))} KM</span><br />

                                </Col>
                                <Col md="4">
                                {e.status === 'marked' ? (
                                <Button x
                                  variant="outline-danger" 
                                  onClick={() => handleRemoveClick(index)}
                                  className="mt-2"
                                >
                                  Remove
                                </Button>
                              ) : (
                                <Button 
                                  variant="outline-success" 
                                  onClick={() => handleAssignClick(index)}
                                  className="mt-2"
                                >
                                  Assign
                                </Button>
                              )}
                                </Col>
                              </Row>
                            
                            </Card.Body>
                          </Card>
                        </div>
                        </div>
                      ))}
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MasterLayout>
      </>
    );
  
};

export default AssignJob;
